import { ReactNode } from "react";

import { AppLayout } from "shared/Layout";
import { fetchSettings } from "shared/SettingsProvider/settings.helper";
import { CACHE_ONE_WEEK } from "utils/config.utils";
import { withApp } from "utils/with-app.utils";
import { fetchTranslations, useI18n } from "utils/with-i18n.utils";

const NetworkCoveragePage = () => {
  const i18n = useI18n();

  return (
    <section className="py-14 px-6 m-auto max-w-5xl lg:py-24">
      <h1 className="mb-6 text-3xl font-medium text-center lg:mb-11 lg:max-w-2xl lg:text-6xl lg:text-left">
        {i18n.t("network.title")}
      </h1>
      <p>{i18n.t("network.map.title")}</p>
      {/* pt-[70%] : CSS trick to keep the aspect ratio of the iframe */}
      <div className="relative pt-[70%] my-6">
        <iframe
          className="absolute inset-0 w-full h-full"
          title={i18n.t("network.title")}
          src="https://cartomr.sfr.fr/mvno2/CartoMap.aspx"
          scrolling="no"
        />
      </div>
      <p className="my-4">
        <span className="font-bold">{i18n.t("network.map.heading")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.verygood")}</span>
        <span> : {i18n.t("network.map.verygood.explanation")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.good")}</span>
        <span> : {i18n.t("network.map.good.explanation")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.limited")}</span>
        <span> : {i18n.t("network.map.limited.explanation")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.4g")}</span>
        <span> : {i18n.t("network.map.4g.explanation")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.3g")}</span>
        <span> : {i18n.t("network.map.3g.explanation")}</span>
      </p>
      <p>
        <span className="font-bold">{i18n.t("network.map.none")}</span>
        <span> : {i18n.t("network.map.none.explanation")}</span>
      </p>
      <p className="my-4">{i18n.t("network.map.footer")}</p>
    </section>
  );
};

NetworkCoveragePage.getLayout = (page: ReactNode, pageProps: any) => (
  <AppLayout {...pageProps}>{page}</AppLayout>
);

export async function getStaticProps() {
  const translations = await fetchTranslations("network-coverage");

  return {
    props: { translations, settings: await fetchSettings() },
    revalidate: CACHE_ONE_WEEK,
  };
}

export default withApp(NetworkCoveragePage);
